<template>
    <div>
        <!-- Bookmaker structure -->
        <!-- <div></div> -->
        <div
            v-if="
                markets &&
                markets.length > 0 &&
                markets[0].outcomes &&
                markets[0].outcomes.length > 0
            "
        >
            <template v-for="(runner, index) in markets[0].outcomes">
                <v-card
                    :key="`key-${index}`"
                    dense
                    light
                    flat
                    tile
                    height="45"
                    class="d-flex align-center item-odds"
                >
                    <v-btn
                        v-if="!twoOdds"
                        text
                        tile
                        color="white"
                        class="text-capitalize text-left justify-start caption font-weight-bold flex-grow-1 flex-shrink-1 pl-2"
                        v-bind="$attrs"
                        v-on="$listeners"
                    >
                        <span class="black--text manage-overflow-two">
                            {{ runner.name }}
                            <span v-if="$auth.loggedIn">
                                <br />
                                <!-- Previous book -->
                                <span
                                    v-if="
                                        books &&
                                        books[markets[0]._id] &&
                                        books[markets[0]._id].length &&
                                        books[markets[0]._id][0].book
                                    "
                                    :class="{
                                        'green--text ':
                                            books[markets[0]._id][0].book[
                                                runner.id
                                            ] > 0,
                                        'red--text':
                                            books[markets[0]._id][0].book[
                                                runner.id
                                            ] < 0,
                                        'black--text ':
                                            books[markets[0]._id][0].book[
                                                runner.id
                                            ] == 0
                                    }"
                                >
                                    {{
                                        books[markets[0]._id][0].book[runner.id]
                                    }}
                                </span>
                                <!-- Book after current bet -->
                                <span
                                    v-if="
                                        newBooksPremium &&
                                        newBooksPremium[markets[0]._id] &&
                                        newBooksPremium[markets[0]._id]
                                            .length &&
                                        newBooksPremium[markets[0]._id][0]
                                            .book &&
                                        newBooksPremium[markets[0]._id][0].book
                                            .length
                                    "
                                    :class="{
                                        'green--text ':
                                            getBooks(
                                                books[markets[0]._id],
                                                runner.id
                                            ) +
                                                getBooks(
                                                    newBooksPremium[
                                                        markets[0]._id
                                                    ],
                                                    runner.id
                                                ) >
                                            0,
                                        'red--text':
                                            getBooks(
                                                books[markets[0]._id],
                                                runner.id
                                            ) +
                                                getBooks(
                                                    newBooksPremium[
                                                        markets[0]._id
                                                    ],
                                                    runner.id
                                                ) <
                                            0,
                                        'black--text ':
                                            getBooks(
                                                books[markets[0]._id],
                                                runner.id
                                            ) +
                                                getBooks(
                                                    newBooksPremium[
                                                        markets[0]._id
                                                    ],
                                                    runner.id
                                                ) ==
                                            0
                                    }"
                                >
                                    <v-icon
                                        v-if="
                                            books &&
                                            books[markets[0]._id] &&
                                            books[markets[0]._id].length &&
                                            books[markets[0]._id][0].book &&
                                            getBooks(
                                                newBooksPremium[markets[0]._id],
                                                runner.id
                                            )
                                        "
                                        size="12"
                                        >mdi-chevron-right
                                    </v-icon>
                                    <!-- {{ books[market._id][0].book[runner.id] }}
                    {{ getBooks(newBooksPremium[market._id][0].book, runner.id) }}
                    {{ getMyRate() }} -->
                                    {{
                                        (getBooks(
                                            books[markets[0]._id],
                                            runner.id
                                        ) /
                                            getMyRate() +
                                            getBooks(
                                                newBooksPremium[markets[0]._id],
                                                runner.id
                                            ))
                                            | currencyFormat(2)
                                    }}
                                </span>
                            </span>
                        </span>
                    </v-btn>
                    <odds-disabled
                        v-if="checkIfSuspended(markets[0])"
                        :text="checkIfSuspended(markets[0])"
                        v-bind="$attrs"
                        v-on="$listeners"
                    ></odds-disabled>
                    <template
                        v-for="(i, key) in xsOnlyOdds(
                            $breakpoint.xsOnly,
                            'back'
                        )"
                    >
                        <btn-odds
                            v-if="
                                ((i === 0 && twoOdds) || !twoOdds) &&
                                (!$auth.user ||
                                    !(
                                        $auth.user &&
                                        !$auth.user.matchOdds &&
                                        market &&
                                        market.markets &&
                                        market.markets.length > 0 &&
                                        market.markets[0].name.toLowerCase() ===
                                            'winner (incl. super over)'
                                    ))
                            "
                            :key="'back' + key"
                            type="back"
                            :class="{
                                'opacity-0': i !== 0 && twoOdds,
                                'flex-grow-1': twoOdds
                            }"
                            :disabled="
                                (i !== 0 && twoOdds) ||
                                !check(
                                    markets[0].outcomes,
                                    index,
                                    !$breakpoint.xsOnly && key !== 2
                                )
                            "
                            @betData="
                                $store.commit('placeBet/openPopover', {
                                    market: markets[0],
                                    runner,
                                    allRunners: markets[0].outcomes,
                                    oddsIndex: i,
                                    odds: runner.odds,
                                    type: 'back',
                                    bettingType: 'premiumsports'
                                })
                            "
                        >
                            <span
                                v-if="
                                    !check(
                                        markets[0].outcomes,
                                        index,
                                        !$breakpoint.xsOnly && key !== 2
                                    )
                                "
                                class="d-block text-center"
                                style="font-weight: 800 !important"
                            >
                                -
                            </span>
                            <span v-else class="d-block text-center">
                                <span class="position-relative">
                                    {{ runner.odds }}
                                </span>
                            </span>
                        </btn-odds>
                    </template>
                    <template
                        v-for="(i, key) in xsOnlyOdds($breakpoint.xsOnly)"
                    >
                        <btn-odds
                            v-if="
                                ((i === 0 && twoOdds) || !twoOdds) &&
                                (!$auth.user ||
                                    !(
                                        $auth.user &&
                                        !$auth.user.matchOdds &&
                                        market &&
                                        market.markets &&
                                        market.markets.length > 0 &&
                                        market.markets[0].name.toLowerCase() ===
                                            'winner (incl. super over)'
                                    ))
                            "
                            :key="'lay' + key"
                            type="lay"
                            :class="{
                                'opacity-0': i !== 0 && twoOdds,
                                'flex-grow-1': twoOdds
                            }"
                            :disabled="true"
                        >
                            <span class="d-block text-center">-</span>
                        </btn-odds>
                    </template>
                </v-card>
                <bet-popover
                    v-if="
                        $breakpoint.smAndDown &&
                        nonBetFairBetSlipOpener(
                            $auth,
                            $store,
                            runner.id,
                            markets[0]._id
                        )
                    "
                    :key="`p-${index}`"
                    :radius-class="
                        markets[0].outcomes.length > 1 &&
                        index !== markets[0].outcomes.length - 1
                            ? 'no-radius'
                            : index === markets[0].outcomes.length - 1
                            ? 'top-radius'
                            : 'all-radius'
                    "
                    :check-id="runner.id"
                ></bet-popover>
            </template>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex"
import cloneDeep from "lodash/cloneDeep"
import OddsDisabled from "@/components/OddsDisabled"
import BtnOdds from "@/components/BtnOdds"
import BetPopover from "@/components/BetPopover"
import socket from "~/plugins/socket.client"
export default {
    name: "NonBetFairItemOdds",
    components: { OddsDisabled, BtnOdds, BetPopover },
    props: {
        market: { type: Object, default: () => {}, required: true },
        runners: { type: Array, default: () => [], required: true },
        twoOdds: { type: Boolean, default: false }
    },
    data() {
        return {
            markets: [],
            socketData: {}
        }
    },
    computed: {
        ...mapState({
            books: (state) => state.betBooks.premiumData,
            newBooksPremium: (state) => state.betBooks.newPremiumData,
            matchIds: (state) => state.placeBet.matchIds,
            minMaxMarket: (state) => state.matchInside.minMaxMarket
        })
    },
    mounted() {
        this.markets = this.runners
        this.markets[0].eventName = this.market.eventName
        if (this.market?.eventId) {
            socket.commonSocket.on(
                `uof_main_market_${this.market.eventId}`,
                (data) => {
                    this.markets = data
                    this.markets[0].eventName = this.market.eventName
                }
            )
        }
    },
    beforeDestroy() {
        this.$store.commit("betBooks/reset_newPremiumData")
        socket.commonSocket.off(`uof_main_market_${this.market.eventId}`)
    },
    methods: {
        getBooks(books, id) {
            let newBook = cloneDeep(books)
            if (newBook && !Array.isArray(newBook)) {
                newBook = [newBook]
            }
            if (newBook && newBook.length && newBook[0] && newBook[0].book) {
                if (!Array.isArray(newBook[0].book)) {
                    newBook[0].book = [newBook[0].book]
                }
                const value = newBook[0].book.find((e) => {
                    return e[id]
                })
                if (value && value[id]) {
                    return value[id] || ""
                } else {
                    return 0
                }
            } else {
                return 0
            }
        },
        xsOnlyOdds(bool, type) {
            if (bool) {
                return [0]
            } else {
                if (type === "back") {
                    return [2, 1, 0]
                }
                return [0, 1, 2]
            }
        },
        check(runner, key, value) {
            return value
                ? false
                : runner &&
                      runner[key] &&
                      runner[key].active &&
                      runner[key].active === 1
        }
    }
}
</script>

<style lang="scss" scoped>
.opacity-0 {
    opacity: 0;
}

.market-down-arrow,
.market-up-arrow {
    position: absolute !important;
    top: 20% !important;
    left: 5px !important;
    z-index: 1 !important;
}
</style>
